import React from 'react';
import { observer } from 'mobx-react-lite';
import { XAxis, YAxis, CartesianGrid, Tooltip, Area, AreaChart } from 'recharts';

import { useTranslation } from 'react-i18next';

import format from 'date-fns/format';
import addHours from 'date-fns/add_hours';

import ObservableAutoSizer from '@vromo/ui/components/ObservableAutoSizer';
import { JobStats } from './DashboardRoot.lazy';

type Props = {
    jobStats: JobStats | Record<string, never>;
};

export default observer(function JobSummaryChart({ jobStats }: Props) {
    const { t } = useTranslation();
    return (
        <ObservableAutoSizer
            customChildren={({ width }) => (
                <AreaChart
                    width={width}
                    height={350}
                    data={jobStats.jobSummaryChartData}
                    margin={{
                        top: 10,
                        right: 30,
                        left: 0,
                        bottom: 0
                    }}>
                    <CartesianGrid strokeDasharray="3 5" />
                    <XAxis
                        dataKey="name"
                        minTickGap={100}
                        tickFormatter={(t) => format(new Date(t), 'ha')}
                    />
                    <YAxis allowDecimals={false} />
                    <Tooltip
                        labelFormatter={(t) =>
                            `${format(new Date(t), 'ha')} - ${format(addHours(t, 1), 'ha')}`
                        }
                    />
                    <Area
                        dataKey="cancelled"
                        name={t('jobSummaryChart.jobsCancelled')}
                        stroke="#ff3f2b"
                        fill="#ff604f"
                    />
                    <Area
                        dataKey="completed"
                        name={t('jobSummaryChart.jobsCompleted')}
                        stroke="#1BA5F5"
                        fill="#1BA5F5"
                    />
                </AreaChart>
            )}></ObservableAutoSizer>
    );
});
